import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from "react";

var IconProfileRound = /*#__PURE__*/function (_React$Component) {
  _inherits(IconProfileRound, _React$Component);

  var _super = _createSuper(IconProfileRound);

  function IconProfileRound(props) {
    _classCallCheck(this, IconProfileRound);

    return _super.call(this, props);
  }

  _createClass(IconProfileRound, [{
    key: "render",
    value: function render() {
      var isServerRendering = function () {
        try {
          return !((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && document !== undefined);
        } catch (e) {
          return true;
        }
      }();

      var prefixCls = !isServerRendering && window.ARCO_PREFIXCLS ? window.ARCO_PREFIXCLS : this.props.prefixCls;
      var className = this.props && this.props.className ? this.props.className + " " : "";

      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        className: className + "i18n-ecom-alliance-icon arco-icon  arco-icon-fill-none arco-icon-profile-round".replace(/arco-/g, prefixCls + "-")
      });

      if (this.props.spin) {
        props.className = props.className + " " + prefixCls + "-icon-loading";
      }

      delete props.prefixCls;
      delete props.spin;
      delete props.isIcon;
      return /*#__PURE__*/React.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "i18n-ecom-alliance-icon arco-icon  arco-icon-fill-none arco-icon-profile-round"
      }, props), /*#__PURE__*/React.createElement("mask", {
        id: "prefix__IconProfileRounda",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 0,
        width: 28,
        height: 28
      }, /*#__PURE__*/React.createElement("circle", {
        cx: 14,
        cy: 14,
        r: 14,
        fill: "#7474D8"
      })), /*#__PURE__*/React.createElement("g", {
        mask: "url(#prefix__IconProfileRounda)"
      }, /*#__PURE__*/React.createElement("circle", {
        cx: 14,
        cy: 14,
        r: 14,
        fill: "#7474D8"
      }), /*#__PURE__*/React.createElement("ellipse", {
        opacity: 0.5,
        cx: 14,
        cy: 30.333,
        rx: 12.833,
        ry: 14,
        fill: "#F5F5FF"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 14,
        cy: 11.667,
        r: 5.833,
        fill: "#DCDDFE"
      })));
    }
  }]);

  return IconProfileRound;
}(React.Component);

IconProfileRound.defaultProps = {
  isIcon: true,
  prefixCls: "arco"
};
export default IconProfileRound;